const fakeData = [
	{
		id: 1,
		name: 'Saint Martin',
		description:
			'Saint Martin is part of the Leeward Islands in the Caribbean Sea. It comprises 2 separate countries, divided between its northern French side, called Saint-Martin, and its southern Dutch side, Sint Maarten.',
		image: 'https://i.pinimg.com/originals/b8/d6/59/b8d659551ef2aa4f6ba2ffe95a883288.jpg',
		lat: 21.427229,
		lang: 92.005806,
	},
	{
		id: 2,
		name: 'SundarBan',
		description:
			'The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India state of West Bengal to the Baleswar River in Bangladesh.',
		image: 'https://images.unsplash.com/photo-1567601916666-581e8d89288b?ixlib=rb-1.2.1&w=1000&q=80',
		lat: 21.949726,
		lang: 89.183327,
	},
	{
		id: 3,
		name: 'Jaflong',
		description:
			'Jaflong is a hill station and tourist destination in the Division of Sylhet, Bangladesh. It is located in Gowainghat Upazila of Sylhet District and situated at the border between Bangladesh and the Indian state of Meghalaya, overshadowed by subtropical mountains and rainforests.',
		image: 'https://1.bp.blogspot.com/-WVRxE7BArtc/TkjKNUYskDI/AAAAAAAAAA4/BTRjyFEdo6U/w1200-h630-p-k-no-nu/600px-Boat_in_river%252C_Bangladesh.jpg2',
		lat: 25.1729658,
		lang: 92.0202881,
	},
];
export default fakeData;
